import { render, staticRenderFns } from "./DestroyModification.vue?vue&type=template&id=1e04607c&scoped=true&"
import script from "./DestroyModification.vue?vue&type=script&lang=ts&"
export * from "./DestroyModification.vue?vue&type=script&lang=ts&"
import style0 from "./DestroyModification.vue?vue&type=style&index=0&id=1e04607c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04607c",
  null
  
)

export default component.exports